import React, { useEffect, useState, useRef } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDomain } from 'src/bff';
import { OneFormState } from 'src/types';
import { useOneFormContext, useTrackingManager } from 'src/feature-app';
import { GeneralInputWidthWrapper } from '.';
import { InputError } from './inputs';
import { styled, Select, TextInput } from '@volkswagen-onehub/components-core';

type WrapperProps = {
	disabled?: boolean;
	themeColor?: string;
};

const Wrapper = styled.div<WrapperProps>`
  opacity: ${(props) => (props.disabled ? '0.5' : '1')};
  & span::before {
   display: none;
  }
  svg {
	fill: ${(props) => (props.themeColor === 'inverted' ? '#ffffff' : '#001E50')};
  }
  option {
	color: #001e50;
	padding-left: 12px;
  }
`;

interface props {
	name: string;
	token: string;
	domain: string;
	nodeValue: string;
	nodeText: string;

	label?: string;
	required?: boolean;
	disabled?: boolean;
	selected?: string;
	noPaddingTop?: boolean;
	addOptions?: { value: string; text: string }[];
	whiteList?: string[];
	blackList?: string[];
	onClick?: (e?: any) => void;
}

export function SelectDpsDomain(props: props) {
	const { name, token, domain, required, disabled, nodeValue, nodeText, noPaddingTop, addOptions, whiteList, blackList } = props;
	const defaultSelected = props.selected;
	const label = props.label ? props.label : 'Selecciona una opción';

	const dispatch = useDispatch();
	const trackingManager = useTrackingManager();
	const { register, errors: contextErrors } = useFormContext();
	const { error: contextError } = useOneFormContext();
	const [error, setError] = useState(false);

	const { formData, formInfo, domainsInfo } = useSelector((state: OneFormState) => state);
	const { fields } = formData;
	const [options, setOptions] = useState<{ value: string; text: string }[]>([]);
	const [selected, setSelected] = useState(null);


	const requestDomain = async () => {
		const response = await fetchDomain(token, domain);
		let options = response.content.map((item) => {
			const value = item.attributes.find((attr: { name: string }) => attr.name == nodeValue)?.value;
			const text = item.attributes.find((attr: { name: string }) => attr.name == nodeText)?.value;
			return { value, text };
		});
		if (whiteList) {
			options = options.filter(({ value, text }) =>
				whiteList.some(white =>
					(value && value.toLowerCase() === white.toLowerCase()) ||
					(text && text.toLowerCase() === white.toLowerCase())
				)
			);
		}
		if (blackList) {
			options = options.filter(({ value, text }) =>
				!blackList.some(black =>
					(value && value.toLowerCase() === black.toLowerCase()) ||
					(text && text.toLowerCase() === black.toLowerCase())
				)
			);
		}
		if (addOptions) {
			options = [...options, ...addOptions];
		}
		setOptions(options);
		setFirstSelected(options);
		dispatch({ type: 'ADD_DOMAIN', payload: { [token]: { [domain]: options } } });
	};

	const setFirstSelected = (options) => {
		if(fields[name]) {
			setSelected(fields[name]);
		}
		else if (defaultSelected) {
			const option = options.find(opt => 
				opt.value === defaultSelected || opt.text === defaultSelected 
			);
			setSelected(option?.value);
		}
	};

	useEffect(() => {
		if(domainsInfo[token] && domainsInfo[token][domain]) {
			setOptions(domainsInfo[token][domain]);
			setFirstSelected(domainsInfo[token][domain]);
		}
		else {
			requestDomain();
		}
	}, []);

	useEffect(() => {
		if (contextError) {
			setError(true);
		} else if (contextErrors.value) {
			setError(true);
		} else if (contextErrors[name]) {
			setError(true);
		} else {
			setError(false);
		}
	}, [contextError, contextErrors]);

	const handleChange = (e: any) => {
		const selectedValue = e.currentTarget.value;
		setSelected(selectedValue);
		setError(false);

		if (selectedValue == '' && required) {
			setError(true);
		} else {
			dispatch({ type: 'UPDATE_FIELDS', payload: { [name]: selectedValue } });
			dispatch({ type: 'UPDATE_LITERAL_FIELDS_STEPS', payload: { [name]: options.find(({value}) => value == selectedValue)?.text } });
		}
	};

	return (
		<GeneralInputWidthWrapper className="dps-select-wrapper" notALayer={formInfo.notALayer} noPaddingTop={noPaddingTop}>
			{options ? (
				<Wrapper
					onClick={() => {
						trackingManager.trackFormFieldClick(
							{
								contentId: label,
							},
							{
								FormFieldName: name,
							},
						);
						//props.onClick();
					}}
					disabled={disabled}
					themeColor={formInfo.formTheme}
				>
					<Select
						disabled={disabled}
						label={label}
						isFloating={true}
						value={selected ? selected : ''}
						name={name}
						onChange={(event) => {
							event.preventDefault();
							handleChange(event);
						}}
						required={required}
						autoFocus={false}
					>
						<option value="" disabled>{label}</option>
						{options.map((option: any, key: number) => {
							return (
								<option key={key} value={option.value}>
									{option.text}
								</option>
							);
						})}
					</Select>
				</Wrapper>
			) : null }

			{ error ? <InputError className="input-error">Este campo es obligatorio</InputError> : null}

			<div style={{display: 'none'}}>
				<TextInput
					name={name}
					value={selected}
					ref={register({
					required: {
						value: required,
						message: '',
					},
					})}
				/>
			</div>

			
		</GeneralInputWidthWrapper>
	);
}
